import { Injectable, OnInit } from "@angular/core";
import { Cookie } from 'ng2-cookies';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthenticationService } from "../../../auth";
import { Observable } from 'rxjs';

@Injectable()
export class ProjectTreeModalService implements OnInit {

    constructor(private http: HttpClient, private authService: AuthenticationService) {}

    ngOnInit(): void {
        this.authService.isTokenValid();
    }

    getHeadSupplierByProjectName(projectName: string): Observable<any> {
        this.authService.isTokenValid();
        const url = `${this.authService.getResourceURL()}/api/v1/employer/project/gov?projectName=${projectName}`;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    getCustomerSupplierByProjectName(projectName: string): Observable<any> {
        this.authService.isTokenValid();
        const url = `${this.authService.getResourceURL()}/api/v1/employer/project/comp?projectName=${projectName}`;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }
}